<template>
    <div id="customerDetail">
        <div class="titlee">
            <!-- | {{customerDetail.phone}} -->
            <div>{{customerDetail.name}} | {{customerDetail.gender=='1'?'男':'女'}}  | <span :class="customerDetail.isVerified==1?'success':'fail'">{{customerDetail.isVerified==1?"已认证":"未认证"}}</span></div>
            <div v-if="customerDetail.statusExpireTime">
                <span class="clock" v-if="countdown[0] / 1 != 0 || countdown[1] / 1 != 0 || countdown[2] / 1 != 0 || countdown[3] / 1 != 0">
                    <span v-if="countdown[0]" class="theme-color">
                        <van-icon name="clock-o" />
                        {{countdown[0]+ "天"}}
                    </span>
                    <span v-else class="fail-color">
                        <van-icon name="clock-o" />
                        <span v-if="countdown[1]">{{countdown[1]+ "时"}}</span><span v-if="countdown[2]">{{countdown[2]+ "分"}}</span>{{countdown[3]+ "秒"}}
                    </span>
                </span>
                <!-- <span v-else>已失效</span> -->
            </div>
        </div>
        <div class="content nowarp">
            <div class="inlineB">
                <p class="colorC l">当前状态</p>
                <p class="l">{{customerDetail.statusName?customerDetail.statusName:'暂无'}}</p>
            </div>
            <div class="inlineB">
                <p class="colorC l">客户归属</p>
                <p class="l">{{customerDetail.belongName?customerDetail.belongName:'暂无'}}</p>
            </div>
            <div class="inlineB">
                <p class="colorC l">归属门店</p>
                <p class="l">{{customerDetail.storeName?customerDetail.storeName:'暂无'}}</p>
            </div>
        </div>
        <van-tabs v-model="active" class="tabs">
            <van-tab title="基本信息">
                <van-cell title="证件类型" :value="(idTypeList[customerDetail.idType-1]||'-')" />
                <!-- <van-cell title="证件号码" :value="(customerDetail.idNo||'-')" /> -->
                <van-cell title="电子邮箱" :value="(customerDetail.email||'-')" />
                <van-cell title="紧急联系人姓名" :value="(customerDetail.contactName||'-')" />
                <van-cell title="紧急联系人关系" :value="(contactList[customerDetail.contactRelation-1]||'-')" />
                <van-cell title="紧急联系人电话" class="space_bet" >
                                <template #right-icon>
                        <a  class="tel" :href="'tel:'+customerDetail.contactPhone">
                        <van-icon name="phone" class="search-phone" color="#fd7e2d"  />
                        拨打
                        </a>
                    
                    </template>
                </van-cell>
                <van-cell title="入住人数" :value="(customerDetail.persons||'-')" />
                <van-cell title="期望月租" :value="(customerDetail.budget||'-')" />
                <van-cell title="来源" :value="(customerDetail.source||'-')" />
                <van-cell v-if="customerDetail.city" title="意向区域" :value="(customerDetail.city||'')+'-'+(customerDetail.area||'')+'-'+(customerDetail.tradeArea||'')" />
                <van-cell v-if="customerDetail.rentType" title="租房方式" :value="customerDetail.rentType == 1?'合租':customerDetail.rentType == 2?'整租':'-'" />
                <van-cell v-if="customerDetail.subwayLine" title="地铁" :value="(customerDetail.subwayLine||'')+'-'+(customerDetail.subwayStation||'')" />
                <van-cell title="创建人" :value="customerDetail.creator" />
                <van-cell title="创建时间" :value="customerDetail.createDate" />
                <van-cell title="归属公司" :value="customerDetail.companyName" />
                <van-cell title="状态到期时间" v-if="customerDetail.statusExpireTime" :value="customerDetail.statusExpireTime" />
                <van-cell title="需求" :value="customerDetail.remark" />
            </van-tab>
            <van-tab title="跟进记录">
                <van-steps direction="vertical" :active="0" active-color="#FD7E2D" active-icon="more" inactive-icon="checked">
                    <van-step v-for="item in customerDetail.trackRecordList || []" :key="item.id">
                        <h4>{{`${item.statusName} 【${item.creator}】`}}</h4>
                        <p>
                            <span style="line-height:26px" v-html="item.content"></span>
                            <!-- <span v-if="item.status == 103">（{{(item.takeLookDate||'').slice(0,16)}}）</span> -->
                            <span v-if="item.status == 108">
                                （
                                <span v-for="(item1,index1) in item.trackRecordReasons" :key="item1.id">{{index1 == 0?item1.name:"，"+item1.name}}</span>）
                            </span>
                        </p>
                        <p v-if="item.remark">{{item.remark}}</p>
                        <p>{{item.createDate}}</p>
                    </van-step>
                </van-steps>
            </van-tab>
            <van-tab title="合约" v-if="customerDetail.customerBelongType !== 1 || customerDetail.isReceipt == 1">
                <div class="body" v-if="customerDetail.contractList.length">
                    <div class="card" v-for="(item,index) in customerDetail.contractList" :key="index" @click="$router.push({path:'/contractDetail',query:{id:item.id}})">
                        <p>
                            <span class="title">
                                <span :class="{'ellipsis':!item.showTitle}" @click.stop="item.showTitle = !item.showTitle">{{item.houseAddress}}{{item.rentType == 1?item.roomNo:""}}</span>
                                | {{item.rentType == 1?"合租":"整租"}}
                            </span>
                        </p>
                        <p>
                            <span>编码：{{item.contractNumber}}</span>
                            <span class="theme-color">{{contractList[item.status-1]}}</span>
                        </p>
                        <p>
                            <span>租客：{{item.customerName}}</span>
                             <!-- | {{item.customerPhone}} -->
                        </p>
                        <p>
                            <span>租期：{{item.startDate}} 到 {{item.endDate}}</span>
                        </p>
                        <p>
                            <span>创建信息：{{item.creator}} | {{item.createDate}}</span>
                            <span class="big">{{item.rental}}元/月</span>
                        </p>
                    </div>
                </div>
                <van-empty v-else description="暂无数据" />
            </van-tab>
            <van-tab title="预订单" v-if="customerDetail.customerBelongType !== 1 || customerDetail.isReceipt == 1">
                <div class="body" v-if="customerDetail.destineContractList.length">
                    <div class="card" v-for="(item,index) in customerDetail.destineContractList" :key="index" @click="$router.push({path:'/destineDetail',query:{id:item.id}})">
                        <p>
                            <span class="title">
                                <span :class="{'ellipsis':!item.showTitle}" @click.stop="item.showTitle = !item.showTitle">{{item.address}}</span>
                                | {{item.rentType == 1?"合租":"整租"}}
                            </span>
                            <span class="theme-color">{{destineList[item.status-1]}} | {{payList[item.createPayStatus-1]}}</span>
                        </p>
                        <p>
                            <span>编号：{{item.destineNumber}}</span>
                        </p>
                        <p>
                            <span>租客：{{item.customerName}} </span>
                            <!-- | {{item.customerPhone}} -->
                        </p>
                        <p>
                            <span>预计入住时间：{{item.orderDate}}</span>
                        </p>
                        <p>
                            <span>创建信息：{{item.creator}} | {{item.createDate}}</span>
                            <span class="big">{{item.amount }}元</span>
                        </p>
                    </div>
                </div>
                <van-empty v-else description="暂无数据" />
            </van-tab>
        </van-tabs>
        <div style="height:1.2rem;"></div>
        <div class="btn">
            <!-- 我的客户 -->
            <a v-if="customerDetail.customerBelongType == 1 && customerDetail.isReceipt == 1" class="font4" :href="'tel:'+customerDetail.phone">
                <van-button type="primary">拨打电话</van-button>
            </a>
            <van-button v-if="$store.state.buttonAuth.indexOf('crm_customerFollow')>-1&&customerDetail.customerBelongType == 1 && customerDetail.isReceipt == 1 && customerDetail.status!=106" class="font4" type="primary" @click="$router.push({path:'customerFollow',query:{id:customerDetail.id,status:customerDetail.status,lastStatus:customerDetail.lastStatus}})">添加跟进</van-button>
            <van-button v-if="$store.state.buttonAuth.indexOf('crm_destineAdd')>-1&&customerDetail.customerBelongType == 1 && customerDetail.isReceipt == 1 && customerDetail.status==104" class="font4" type="primary" @click="$router.push({path:'destineAdd',query:{customerId:customerDetail.id}})">下定</van-button>
            <van-button v-if="$store.state.buttonAuth.indexOf('crm_customerContract')>-1&&customerDetail.customerBelongType == 1 && customerDetail.isReceipt == 1&& customerDetail.status==104" class="font3" type="primary" @click="goContract">签约</van-button>
            <van-button v-if="$store.state.buttonAuth.indexOf('crm_customerTransfer')>-1&&customerDetail.customerBelongType == 1 && customerDetail.isReceipt == 1" class="font3" type="primary" @click="$router.push({path:'customerTransfer',query:{id:customerDetail.id}})">转让</van-button>
            <!-- 其他人的私有客户 -->
            <a v-if="customerDetail.customerBelongType == 2" :href="'tel:'+customerDetail.belongPhone">
                <van-button class="font5" type="primary">拨打归属人电话</van-button>
            </a>
            <!-- 我的门店下公共客户 || 无归属 -->
            <van-button v-if="$store.state.buttonAuth.indexOf('crm_grap')>-1&&customerDetail.customerBelongType == 3 || customerDetail.customerBelongType == 5" class="font1" type="primary" block @click="grap">抢单</van-button>
            <!-- 其他门店公共客户 -->
            <van-button v-if="$store.state.buttonAuth.indexOf('crm_customerGet')>-1&&customerDetail.customerBelongType == 4" class="font1" type="primary" block @click="showGet = true">获取客户</van-button>
            <!-- 接单 -->
            <van-button v-if="$store.state.buttonAuth.indexOf('crm_receiveCustomer')>-1&&customerDetail.customerBelongType == 1 && customerDetail.isReceipt == 0" class="font1" type="primary" block @click="receipt">接单</van-button>

            <van-button v-if="$store.state.buttonAuth.indexOf('crm_customerFTransfer')>-1" class="font3" type="primary" @click="$router.push({path:'customerTransfer',query:{id:customerDetail.id,from:'1'}})">强制转让</van-button>
        </div>
        <!-- 获取客户弹框 -->
        <van-dialog v-model="showGet" title="获取客户" show-cancel-button :overlay="false" :before-close="getBefore">
            <van-form ref="formGet" input-align="center">
                <van-field readonly clickable name="sotreId" :value="getQuery.name" placeholder="选择门店" @click="showStore = true" :rules="[{ required: true, message: '请选择门店' }]" />
            </van-form>
        </van-dialog>
        <!-- 门店 -->
        <van-popup v-model="showStore" position="bottom">
            <van-picker show-toolbar :columns="storeList" value-key="name" @confirm="item => { getQuery=item;showStore=false }" @cancel="showStore = false" />
        </van-popup>
    </div>
</template>

<script>
import { mapState } from "vuex";
import {
    requestCustomerDetail,
    requestCustomerGrap,
    requestPCStore,
    requestCustomerGet,
    requestReceiveTransfer,
} from "@/api";
import { getCountdown, getMinuteInteger } from "@/utils";
export default {
    name: "customerDetail",
    data() {
        return {
            active: 0,
            customerDetail: {
                name: "",
                gender: "1",
                phone: "",
                status: "1",
                belongName: "",
                storeName: "",
                customerBelongType: "1", //类型（个人，公共）
                //基本信息
                idType: "",
                idNo: "",
                email: "",
                contactName: "",
                contactRelation: "",
                contactPhone: "",
                persons: "",
                expectedRent: "",
                source: "",
                creator: "",
                createDate: "",
                remark: "",
                contractList: [],
                destineContractList: [],
                trackRecordList: [],
            },
            countdown: [0, 0, 0, 0],
            //获取客户
            getQuery: {
                name: "",
                id: "",
            },
            showGet: false,
            showStore: false,
            storeList: [],
            timer: "",
        };
    },
    computed: {
        ...mapState([
            "idTypeList",
            "destineList",
            "payList",
            "contractList",
            "customerList",
            "contactList",
        ]),
    },
    created() {
        this.getDetail();
        this.getPCStore();
    },
    mounted() {},
    methods: {
        getDetail() {
            const toast1 = this.$toast.loading({
                forbidClick: true,
                duration: 0,
                message: "加载中...",
            });
            requestCustomerDetail(this.$route.query.id)
                .then((res) => {
                    res.data.contractList.forEach((d) => {
                        d.showTitle = false;
                    });
                    res.data.destineContractList.forEach((d) => {
                        d.showTitle = false;
                    });
                    this.customerDetail = res.data;
                    this.getQuery.id = this.customerDetail.storeId;
                    if (res.data.statusExpireTime) {
                        if (
                            new Date(
                                res.data.statusExpireTime.replace(/-/g, "/")
                            ) > new Date()
                        ) {
                            let date = getMinuteInteger(
                                res.data.statusExpireTime
                            );
                            this.countdown = getCountdown(date);
                            this.timer = setInterval(() => {
                                this.countdown = getCountdown(date);
                                if (
                                    this.countdown[0] / 1 == 0 &&
                                    this.countdown[1] / 1 == 0 &&
                                    this.countdown[2] / 1 == 0 &&
                                    this.countdown[3] / 1 == 0
                                ) {
                                    //客户过期
                                    clearInterval(this.timer);
                                    requestCustomerDetail(
                                        this.$route.query.id
                                    ).then((res1) => {
                                        res1.data.contractList.forEach((d) => {
                                            d.showTitle = false;
                                        });
                                        res1.data.destineContractList.forEach(
                                            (d) => {
                                                d.showTitle = false;
                                            }
                                        );
                                        this.customerDetail = res.data;
                                        this.getQuery.id = this.customerDetail.storeId;
                                    });
                                }
                            }, 1000);
                        }
                    }
                    toast1.clear();
                })
                .catch((err) => {
                    toast1.clear();
                });
        },
        //门店下拉
        getPCStore() {
            requestPCStore().then((res) => {
                res.data.forEach((d) => {
                    d.text = d.name;
                    d.value = d.id;
                });
                this.storeList = res.data;
            });
        },
        //签约
        goContract() {
            if (this.customerDetail.isVerified != 1) {
                this.$toast.fail("该客户未实名认证,请先去个人中心进行实名认证");
                return;
            }
            this.$router.push({
                path: "contractAdd",
                query: { customerId: this.customerDetail.id },
            });
        },
        //抢单
        grap() {
            this.$dialog.confirm({
                title: "提示",
                message: "确认抢单",
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                beforeClose: (action, done) => {
                    if (action === "confirm") {
                        requestCustomerGrap(this.customerDetail.id)
                            .then((res) => {
                                done();
                                this.$toast.success({
                                    message: "抢单成功",
                                    // forbidClick: true,
                                    onClose: () => {},
                                });
                                this.$router.push({
                                    path: "customerList",
                                });
                            })
                            .catch((err) => {
                                done(false);
                            });
                    } else {
                        done();
                    }
                },
            });
        },
        //获取客户
        getBefore(action, done) {
            if (action === "confirm") {
                this.$refs.formGet
                    .validate()
                    .then((valid) => {
                        requestCustomerGet(
                            this.customerDetail.id,
                            this.getQuery.id
                        )
                            .then((res) => {
                                this.$toast({
                                    type: "success",
                                    message: "获取成功!",
                                    // forbidClick: true,
                                    onClose: () => {},
                                });
                                this.getQuery = {};
                                this.getDetail();
                                done();
                            })
                            .catch((err) => {
                                done(false);
                            });
                    })
                    .catch((err) => {
                        done(false);
                    });
            } else {
                done();
            }
        },
        //接单
        receipt() {
            this.$dialog.confirm({
                message: "确认接单？",
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                beforeClose: (action, done) => {
                    if (action === "confirm") {
                        requestReceiveTransfer(this.$route.query.id)
                            .then((res) => {
                                this.$toast.success({
                                    message: "接单成功",
                                    // forbidClick: true,
                                    onClose: () => {},
                                });
                                this.getDetail();
                                done();
                            })
                            .catch((err) => {
                                done(false);
                            });
                    } else {
                        done();
                    }
                },
            });
        },
    },
    destroyed() {
        clearInterval(this.timer); // 清除定时器
        this.timer = null;
    },
    watch: {},
};
</script>
<style lang="scss" scoped>
@import "../common/scss/variable.scss";
#customerDetail {
    .colorC {
        color: $colorC;
    }
    .fail-color {
        color: $fail-color;
    }
    .theme-color {
        color: $theme-color;
    }
    .titlee {
        padding: 0.2rem 0.42667rem;
        background-color: #fff;
        font-size: 0.3rem;
        display: flex;
        justify-content: space-between;
        position: relative;
        &::after {
            position: absolute;
            box-sizing: border-box;
            content: " ";
            pointer-events: none;
            right: 0;
            bottom: 0;
            left: 0;
            border-bottom: 0.02667rem solid #ebedf0;
            -webkit-transform: scaleY(0.5);
            transform: scaleY(0.5);
        }
    }
    .clock {
        i {
            vertical-align: middle;
        }
    }
    .content {
        background-color: #fff;
        display: flex;
        // border-radius: 0.2rem;
        align-items: center;
        justify-content: center;
        flex-wrap: wrap;
        &.nowarp {
            flex-wrap: nowrap;
        }
        .inlineB {
            flex: 1;
            padding: 0.2rem 0;
            width: 33.3%;
            min-width: 33.3%;
            max-width: 33.3%;
            position: relative;
            p.l {
                line-height: 0.7rem;
                height: 0.7rem;
            }
            &:not(:last-child)::after {
                height: 50%;
                position: absolute;
                box-sizing: border-box;
                content: " ";
                pointer-events: none;
                right: 0;
                top: 50%;
                transform: translateY(-50%);
                border-right: 0.02667rem solid #ebedf0;
                z-index: 99;
            }
        }
    }
    .tabs {
        /deep/.van-tabs__wrap {
            margin: 0.2rem 0;
        }
        /deep/.van-tabs__content {
            height: calc(100vh - 5.5rem);
            overflow: scroll;
        }
        .van-steps {
            text-align: left;
            padding-left: 2rem;
            /deep/.van-step__title {
                padding-left: 0.3rem;
                p {
                    padding-top: 0.2rem;
                }
            }
        }
        .body {
            // padding-top: 0.001rem;
            font-size: 0.35rem;
            margin-top: 0.3rem;
            .card {
                background: #fff;
                margin: 0.3rem;
                border-radius: 0.2rem;
                color: $color9;
                padding: 0.2rem 0;
                // margin: 0.2rem 0;
                p {
                    text-align: left;
                    display: flex;
                    justify-content: space-between;
                    padding: 0 0.4rem;
                    line-height: 0.8rem;
                    // height: 0.8rem;
                    .title {
                        font-size: 0.35rem;
                        font-weight: 600;
                        height: auto;
                        color: #000;
                        // span {
                        //     max-width: 4.5rem;
                        //     vertical-align: top;
                        //     overflow: hidden;
                        //     display: inline-block;
                        //     height: auto;
                        //     text-overflow: ellipsis;
                        // }
                        // .ellipsis {
                        //     white-space: nowrap;
                        // }
                    }
                    .big {
                        font-size: 0.4rem;
                    }
                }
            }
            > .card:first-child {
                margin-top: 0;
            }
            .theme-color {
                color: $theme-color;
            }
        }
    }
    .btn {
        width: 100%;
        position: fixed;
        bottom: 0;
        left: 0;
        border-radius: 0.1rem;
        overflow: hidden;
        display: flex;
        /deep/.van-button {
            margin-left: -1px;
            border: none;
            border-radius: 0;
            flex: 1;
            padding: 0%;
            &:not(:last-child)::after {
                height: 50%;
                position: absolute;
                box-sizing: border-box;
                content: " ";
                pointer-events: none;
                right: 0;
                top: 50%;
                transform: translateY(-50%);
                border-right: 0.02667rem solid #ebedf0;
                z-index: 99;
            }
        }
        a {
            color: #fff;
            flex: 1;
            button {
                width: 100%;
            }
            position: relative;
            &::after {
                height: 50%;
                position: absolute;
                box-sizing: border-box;
                content: " ";
                pointer-events: none;
                right: 0;
                top: 50%;
                transform: translateY(-50%);
                border-right: 0.02667rem solid #ebedf0;
                z-index: 99;
            }
        }
        .font4 {
            width: 2.7rem;
        }
        .font3 {
            width: 1.8rem;
        }
        // .font5 {
        //   width: 51%;
        // }
        .font1 {
            width: 100%;
            margin-left: 0;
        }
    }
}
.success {
    color: $success-color;
    .van-button {
        border-radius: 1rem;
        transform: translateY(-0.1rem);
    }
}
.fail {
    color: $fail-color;
    .van-button {
        border-radius: 1rem;
        transform: translateY(-0.1rem);
    }
}
</style>
